const SETTINGS_KEY = 'koda_settings';

export const LANGUAGE_OPTIONS = [
  'English',
  'French',
  'German',
  'Portuguese',
  'Spanish',
] as const;

export type SupportedLanguage = (typeof LANGUAGE_OPTIONS)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'English';

function detectSystemLanguage(): SupportedLanguage {
  try {
    const preferred =
      (Array.isArray(navigator.languages) && navigator.languages[0]) ||
      navigator.language ||
      '';

    const baseCode = preferred.toLowerCase().split(/[-_]/)[0];

    switch (baseCode) {
      case 'fr':
        return 'French';
      case 'de':
        return 'German';
      case 'pt':
        return 'Portuguese';
      case 'es':
        return 'Spanish';
      default:
        return DEFAULT_LANGUAGE;
    }
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

const isSupportedLanguage = (value: unknown): value is SupportedLanguage =>
  typeof value === 'string' && LANGUAGE_OPTIONS.includes(value as SupportedLanguage);

const readSettings = (): Record<string, unknown> => {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

export function getSavedLanguage(): SupportedLanguage {
  const settings = readSettings();
  return isSupportedLanguage(settings.language)
    ? settings.language
    : DEFAULT_LANGUAGE; // location-based auto-detect paused
}

export function setSavedLanguage(language: SupportedLanguage): void {
  const current = readSettings();
  localStorage.setItem(SETTINGS_KEY, JSON.stringify({ ...current, language }));
  window.dispatchEvent(new Event('storage'));
}
